// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"88ba7ce7","425":"0fccd852","900":"b19024f4"}[chunkId] + ".chunk.js";
};